<div class="si-loader">
  <div class="si-loader_container" *ngIf="show">
    <div class="si-loader_circle"
         role="progressbar"
         aria-busy="true"
         aria-live="polite"
         aria-label="Cargando">
       <svg class="si-p-progress-spinner-svg" viewBox="25 25 50 50" [attr.data-pc-section]="'root'">
        <circle class="si-p-progress-spinner-circle" cx="50" cy="50" r="20" stroke-miterlimit="10"/>
      </svg>
    </div>
  </div>
</div>